module.exports = __webpack_public_path__ + "media/packs/images/table-expand-2d72fea729e7e55b553796be3d1ea19a.svg";